import { Table, Empty } from "antd"
import { TableCustomStyled } from "./styled"

function TableCustom(props) {
  const expandable = {
    expandRowByClick: true,
    // hideExpandIcon: true,
  };
  const columnsWithIndex = props.columns
    ? [
      {
        title: "STT",
        key: "index",
        align: "center",
        render: (_, __, index) =>
          props.pagination ? (props.pagination?.current - 1) * props.pagination?.pageSize + index + 1 : index + 1,
      },
      ...props.columns,
    ]
    : [];
  return (
    <TableCustomStyled
      noMrb={props?.noMrb}
      isPrimary={props?.isPrimary}
      showPagination={true}
    >
      <Table
        {...props}
        expandable={{
          defaultExpandAllRows: true

        }}
        columns={columnsWithIndex}
        bordered
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={props?.textEmpty}
            />
          ),
        }}
        // scroll={props?.dataSource ? { x: "100%" } : {}}

      />
    </TableCustomStyled>
  )
}

export default TableCustom

export const SELECTION_COLUMN = Table.SELECTION_COLUMN
